// extracted by mini-css-extract-plugin
export default {"centered":"Login_centered__5mlGj","centeredText":"Login_centeredText__xZ3TT","form":"Login_form__UohUC","submitButton":"Login_submitButton__SmN6v"};